export default "__VITE_ASSET__DfW2vt3R__"